<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content">
      <el-form :model="resData" :label-width="labelWidthL" >
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblServiceNumber')">
              <idc-input v-model="resData.svcNo" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblICISOderNumber')">
              <idc-input v-model="resData.icisOderNo" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblReceiptDate')">
              <template>
                <el-date-picker
                  v-model="resData.rcpDt"
                  size="mini"
                  type="date"
                  align="left"
                  value-format="yyyyMMdd"
                  placeholder="YYYY/MM/DD"
                  :disabled="!isWrite"
                  style="width: 100%;"
                />
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblIDCName')">
              <template>
                <el-select
                  size="mini"
                  v-model="resData.idcCd"
                  :placeholder="$t('messages.plSelect')"
                >
                  <el-option
                    v-for="(item, index) in orderIdcList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblServiceName')">
              <template>
                <el-select
                  size="mini"
                  v-model="resData.svcTypeCd"
                  :placeholder="$t('messages.plSelect')"
                >
                  <el-option
                    v-for="(item, index) in svcTypeCdList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblOrderType')">
              <template>
                <el-select
                  size="mini"
                  v-model="resData.oderTypeIcisCd"
                  :placeholder="$t('messages.plSelect')"
                >
                  <el-option
                    v-for="(item, index) in oderTypeIcisCdList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" :xs="24">
            <el-form-item
              :label="$t('messages.lblOrderReason')"
              :label-width="!$isMobile() ? labelWidthA : labelWidthL"
            >
              <idc-input v-model="resData.oderWhyIcisCd" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" :xs="24">
            <el-form-item :label="$t('messages.lblRemark')">
              <idc-input v-model="resData.rmark" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblExpOpenDate')">
              <template>
                <el-date-picker
                  v-model="resData.ohYmd"
                  size="mini"
                  type="date"
                  align="left"
                  value-format="yyyyMMdd"
                  placeholder="YYYY/MM/DD"
                  :disabled="!isWrite"
                  style="width: 100%; padding-left:5px;"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblContractTerm')">
              <template>
                <el-date-picker
                  v-model="resData.cperd"
                  size="mini"
                  type="date"
                  align="left"
                  value-format="yyyyMMdd"
                  placeholder="YYYY/MM/DD"
                  :disabled="!isWrite"
                  style="width: 100%; padding-left:5px;"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblContractExpiryDate')">
              <template>
                <el-date-picker
                  v-model="resData.contExpPamYmd"
                  size="mini"
                  type="date"
                  align="left"
                  value-format="yyyyMMdd"
                  placeholder="YYYY/MM/DD"
                  :disabled="!isWrite"
                  style="width: 100%; padding-left:5px;"
                />
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-box" v-if="!this.isTemplate && !$isMobile()">
        <el-button type="save" size="large" @click="onSave" v-if="isWrite"
          :disabled="isTemplate">{{ $t("messages.btnSave") }}</el-button>
      </div>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
  </div>
</template>

<script>
import IdcInput from "@/components/common/IdcInput";

export default {
  components: {
    IdcInput,
  },
  props: {
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      labelWidthL: 50 + "%",
      labelWidth: 100 / 3 + "%",
      labelWidthA: 100 / 4 + "%",
      resData: {},
      orderIdcList: [],
      svcTypeCdList: [],
      oderTypeIcisCdList: [],
      currPrcssTrtDataCnctId: "",
    };
  },
  mounted() {
    if (this.$isMobile()) {
      this.labelWidthL = this.labelWidth;
    }

    this.setidcCd();
    this.setComCd();

    this.getWrkOderBasInfo(true);
  },
  watch: {
    prcssTrtDataCnctId() {
      this.getWrkOderBasInfo(true);
    },
  },
  methods: {
    setidcCd(){

      let idcResData = [];

      this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.getIdcCdList, {})
        .then((res) => {
          if (res.data !== "") {
            res.data.resData.map((data) => {
              idcResData.push({
                label: data.idcCdNm,
                value: data.idcCd,
              });
            });
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.orderIdcList = idcResData;
        });

    },
    setComCd() {
      this.setComCdList({upCd: 35}, (resData) => {
        this.svcTypeCdList = resData;
      });
      /* this.setComCdList({upCd: 35}, (resData) => {
        this.svcNmList = resData;
      }); */
      this.setComCdList({upCd: 81}, (resData) => {
        this.oderTypeIcisCdList = resData;
      });
    },
    //공통콤보박스 세팅
    setComCdList(reqData, callback) {
      let resData = [];
      //axios
      
      this.$BIZ_SERVICE
      .post(this.$API_URLS.Com.getCdList, reqData)
      .then((res) => {

        if (res.data !== "") {
          if(reqData.upCd == 81){ //오더유형값 타입이 String이므로 value값을 String으로 변환
            res.data.resData.map(data=> {
              resData.push({
                label: data.cdHnglNm,
                value: String(data.cd)
              });
            });
          }else{
            res.data.resData.map(data=> {
              resData.push({
                label: data.cdHnglNm,
                value: data.cd
              });
            });
          }
        } else {
          resData = [];
        }
        callback(resData);
        
      })
      .catch((error) => {
          
      }).finally(()=>{

      });
      
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.resData;
    },
    chkValidateData() {
      if(this.mandDataChkYn != 'Y'){
        return true;
      }else{
        if(this.currPrcssTrtDataCnctId != null && this.currPrcssTrtDataCnctId != ''){
          return true;
        }else{
          return false;
        }
      }
    },
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    async getWrkOderBasInfo(initFlag) {
      //console.log('===> prcssTrtDataCncnId : ' + this.prcssTrtDataCnctId);
      //console.log(this.scrnGetApi) //getWrkOderBasInfo
      if (initFlag) {
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId;
        }
        else{
          if(this.defaultValue && Object.keys(this.defaultValue).length > 0 && this.isWrite){
            this.resData = this.defaultValue;
          }
          return;
        }
      }

      const data = await this.$BIZ_SERVICE
      .post(this.scrnGetApi, {prcssTrtDataCnctId : this.prcssTrtDataCnctId})
      if (data.data.resData) {
        this.resData = data.data.resData;
        //console.log("oder register : " + this.resData);
      }
      
    },
    //저장
    async onSave() {
      this.setReqData();

      var obj = {};

      obj.orderInfoList = this.resData;

      this.$BIZ_SERVICE.post(this.scrnPostApi, this.resData)
      .then(async(res) => {
        //저장 성공 후 공정처리연결ID 재매핑
        this.currPrcssTrtDataCnctId = res.data.resData
        //공정처리데이터연결아이디 재조회
        await this.$store.dispatch("wflowStore/geteWflowPrcssTrtDataCnctList", {
          exeWflowId: this.exeWflowId,
          stepCd: Number(this.stepCd),
        });
        alert("등록되었습니다.");

        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getWrkOderBasInfo(false);
        });
    },
    //데이터 삽입
    setReqData(){
      this.resData.exeWflowId  = this.exeWflowId
      this.resData.prcssId     = this.subPrcssId
      this.resData.stepCd      = this.stepCd
      this.resData.scrnId      = this.scrnId
      // this.form.data.scrnActionId = this.scrnActonList     //TODO 확인 필요
      // this.form.data.trtrId       = this.ticketInfo.trtrId // TODO 스케줄에서 조회 시 오류나서 임시 막음
      this.resData.ticktId     = (this.ticketInfo ? this.ticketInfo.ticktId : null)
      this.resData.mainPrcssId = this.mainPrcssId
      this.resData.subPrcssId  = this.subPrcssId
      this.resData.prcssTrtDataCnctId = this.currPrcssTrtDataCnctId
      this.resData.wflowScrnId = this.wflowScrnId
    },
  },
};
</script>
<style lang="scss" scoped>
  .btn-box {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .el-button {
    // 22.03.14 누락사항 반영
    margin-top: 20px;
    height: 50px;
  }
  .input-fl {
  display: flex;
  align-items: center;
  gap: 5px;
  .el-button {
    margin-top: 3px;
  }
}
</style>
